import { render, staticRenderFns } from "./DownloadDescription.vue?vue&type=template&id=06fbb8cc&"
import script from "./DownloadDescription.vue?vue&type=script&lang=js&"
export * from "./DownloadDescription.vue?vue&type=script&lang=js&"
import style0 from "./DownloadDescription.vue?vue&type=style&index=0&id=06fbb8cc&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports